import { EmailDeliveryStatus } from "./email-delivery.type";
import { Injectable } from "@angular/core";
import { HttpClient } from "@angular/common/http";
import { Observable } from "rxjs";

@Injectable()
export class EmailDeliveryService{

    constructor(private http: HttpClient) {}

    startTroubleshooting(): Observable<EmailDeliveryStatus> {
        return this.http.post<EmailDeliveryStatus>('/api/troubleshoot/email/start', {})
    }

    status(userId: string): Observable<EmailDeliveryStatus> {
        return this.http.get<EmailDeliveryStatus>(`/api/troubleshoot/email/${userId}` )
    }
}